import React, { useState, useRef, useEffect } from 'react';
import axios from "axios";
import useAuth from '../hooks/useAuth';

import { useNavigate, useLocation } from 'react-router-dom';

const Login = () => {
    const { setAuth } = useAuth();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const userRef = useRef();  // para colocar o campo a ter o focus no arranque da pagina

    const [values, setValues] = useState({ username: '', password: '' });
    const [errors, setErrors] = useState({});
    const [erroLogin, setErroLogin] = useState(null);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // set focus on field on page load
    useEffect(() => {
        //userRef.current.focus();
    }, []);


    const handleLogin = async (event) => {
        event.preventDefault();
        setErroLogin('');
        console.log("Login > handleLogin > START");

        try {
            const response = await axios.post(`${baseURL}/login`, values, { withCredentials: true });

            console.log("Login > handleLogin > response.data: ", JSON.stringify(response.data));

            if (response.data.loginStatus) {

                //const accessToken = response?.data?.accessToken;
                const user_id = response?.data?.user_id;
                const group_name = response?.data?.group_name;
                const group_id = response?.data?.group_id;

                // Fetch permissions
                const permissionsResponse = await axios.post(`${baseURL}/group_permissions`, { group_id: group_id }, { withCredentials: true });
                const permissions = permissionsResponse.data;

                console.log("Login > handleLogin > group_name: ", group_name)
                //console.log("Login > handleLogin > permissions: ", permissions);

                setAuth({
                    isAuthenticated: true,
                    user: values.username,
                    user_id: user_id,
                    group_id: group_id,
                    group_name: group_name,
                    permissions: permissions  // Include permissions here
                });


                navigate('/');
            } else {
                setErroLogin(response.data.message);
            }
        } catch (err) {
            if (!err?.response) {
                setErroLogin("Sem resposta do servidor");
            } else if (err.response?.status === 400) {
                setErroLogin("Sem utilizador ou password");
            } else if (err.response?.status === 401) {
                setErroLogin("Não autorizado");
            } else {
                setErroLogin("Login falhou");
            }
        }
    };

    return (
        <div className="d-flex vh-100 justify-content-center align-items-center">
            <div className="p-3 bg-white w-25">
                <div className="text-danger">{erroLogin && erroLogin}</div>
                <h2>Login</h2>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label htmlFor="username">Username</label>
                        <input type="text" name="username" className="form-control" value={values.username}
                            onChange={(e) => setValues({ ...values, username: e.target.value })}
                            ref={userRef} />
                        {errors.username && <span className="text-danger">{errors.username}</span>}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password">Password</label>
                        <input type="password" name="password" className="form-control" value={values.password}
                            onChange={(e) => setValues({ ...values, password: e.target.value })} />
                        {errors.password && <span className="text-danger">{errors.password}</span>}
                    </div>
                    <button type='submit' className="btn btn-success">Login</button>
                </form>
            </div>
        </div>
    );
};

export default Login;